<template>
  <v-card
    v-ripple
    class="background d-flex flex-row overflow-hidden mb-4 mx-4"
    :style="{
      borderRadius: '0',
    }"
    flat
  >
    <v-card
      class="d-flex flex-row w-50 elevation-0"
      :to="`/watch?v=${video.id}`"
    >
      <v-img
        :src="thumbnail"
        aspect-ratio="1.7778"
        style="position: relative; width: 8rem"
        
        :style="{
          borderRadius:'1rem',
        }"
      >
      </v-img>
   

    </v-card>
<!--
    <v-spacer></v-spacer>
    <div class="d-flex w-50 flex-column">
      <v-btn
        text
        tile
        elevation="0"
        class="flex-grow-1"
        style="width: 2rem !important"
        @click="deleted"
      >
        <v-icon>mdi-delete</v-icon>
      </v-btn>
    </div>-->



  </v-card>
     <div
        
        style="font-size: 0.75rem !important"
        class="d-flex flex-column ml-2"
      >
        <b
          class="text-left"
          style="
             {
              height: 1.5rem;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
              word-wrap: break-word;
              white-space: normal;
            }
          "
          >{{ video.title }}
        </b>
        <div
          class="background--text caption mt-2 text-left d-inline-block text-truncate"
          style="
             {
              height: 0.75rem;
            }
          "
        >
          {{ video.channel }}
        </div>
      </div>
</template>

<script>
export default {
  props: { video: { type: Object, required: true } },
  computed: {
    thumbnail() {
      return `https://img.youtube.com/vi/${this.video.id}/hqdefault.jpg`;
    },
  },
  methods: {
    deleted() {
      this.$emit("deleted");
    },
  },
};
</script>